import axios from 'axios';
export default axios.create({
  baseURL: 'https://backend.alabar-sd.com/api/',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000 * 60, // Wait for 1 minute
});
